export enum RenewalPreferences {
    RENEWAL_THIS_YEAR = "renewal_this_year",
    RENEWAL_EVERY_YEAR = "renewal_every_year",
    NO_RENEWAL = "no_renewal",
}




// WEBPACK FOOTER //
// ./src/components/enums/enums.ts